
export const STORY_CATEGORIES = {
    fables: {
      key: "fables",
      label: "Fabeln",
      emoji: "🦊",
    },
    legends: {
      key: "legends",
      label: "Legenden",
      emoji: "🏰",
    },
    jokes: {
      key: "jokes",
      label: "Witze",
      emoji: "😂",
    },
    fairytales: {
      key: "fairytales",
      label: "Märchen",
      emoji: "👸",
    },
    scripts: {
      key: "scripts",
      label: "Skripte",
      emoji: "🎭",
    },
    poetry: {
      key: "poetry",
      label: "Gedichte",
      emoji: "📜",
    },
  };

  export const getCategory = (key) => {
    const normalized = key?.toLowerCase();
    return STORY_CATEGORIES[normalized] || {
      label: key,
      emoji: "📖",
    };
  };

  export const DIFFICULTY_LEVELS = [
    { value: 1, label: "Sehr leicht", emoji: "🌱" },
    { value: 2, label: "Leicht", emoji: "🌿" },
    { value: 3, label: "Mittel", emoji: "📘" },
    { value: 4, label: "Anspruchsvoll", emoji: "⭐" },
    { value: 5, label: "Schwierig", emoji: "🚀" },
  ];